/**
 * 常用工具
 */
export default class Tool {
    /**
     * 存储localStorage
     */
    static setStore( name, content ) {
        if (!name) return
        if (typeof content !== 'string') {
            content = JSON.stringify(content)
        }
        window.localStorage.setItem(name, content)
    }
  
    /**
     * 获取localStorage
     */
    static getStore(name) {
      if (!name) return null
      return window.localStorage.getItem(name)
    }
  
    /**
     * 删除localStorage
     */
    static removeStore(name) {
      if (!name) return
      window.localStorage.removeItem(name)
    }
  
    
    /**
     * 获取服务端cookie
     */
    static getServerCookie(key, str) {
      if (!str) {
        return false
      }
      if (str.includes(String(key))) {
        str.split(';').map((v, i) => {
          if (v.includes(key)) {
            return v.split('=')[1]
          }
        })
      } else {
        return false
      }
    }
    /**
     * 格式化对象参数
     */
    static serialize(obj, prefix) {
      var str = [],
        p
      for (p in obj) {
        if (obj.hasOwnProperty(p)) {
          var k = prefix ? prefix + '[' + p + ']' : p,
            v = obj[p]
          str.push((v !== null && typeof v === 'object')
            ? Tool.serialize(v, k)
            : k + '=' + encodeURIComponent(v))
        }
      }
      return str.join('&')
    }
  
    /**
     * rsa加密
     */
    static rsa(data) {
      var {
        JSEncrypt
      } = require('jsencrypt')
      var b64map =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
      var b64pad = '='
  
      function hex2b64(h) {
        var i
        var c
        var ret = ''
        for (i = 0; i + 3 <= h.length; i += 3) {
          c = parseInt(h.substring(i, i + 3), 16)
          ret += b64map.charAt(c >> 6) + b64map.charAt(c & 63)
        }
        if (i + 1 == h.length) {
          c = parseInt(h.substring(i, i + 1), 16)
          ret += b64map.charAt(c << 2)
        } else if (i + 2 == h.length) {
          c = parseInt(h.substring(i, i + 2), 16)
          ret += b64map.charAt(c >> 2) + b64map.charAt((c & 3) << 4)
        }
        while ((ret.length & 3) > 0) {
          ret += b64pad
        }
        return ret
      }
      JSEncrypt.prototype.encryptLong = function(string) {
        var k = this.getKey()
        // var maxLength = (((k.n.bitLength()+7)>>3)-11);
        var maxLength = 117
  
        try {
          var lt
          var ct = ''
  
          if (string.length > maxLength) {
            lt = string.match(/.{1,117}/g)
            lt.forEach(function(entry) {
              var t1 = k.encrypt(entry)
              ct += t1
            })
            return hex2b64(ct)
          }
          var t = k.encrypt(string)
          var y = hex2b64(t)
          return y
        } catch (ex) {
          return false
        }
      }
      //公钥
      const publicKey =
        'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDgMHA+3pZIztqqp3kkAtnLXnfQUksUGRd0R3fy9g1MMMGs6VVhF6RuxdRI9ZyRUhjeEy6n5K7fPXlt7bPnjsFsfuYKcICJsnVxU4M5ptC0h94rCvb+ZvNw8uBMNcbqdCx/KSSCYQ+ujSSAo0SsOZZLn35qW5pRn3Tp+m6MtErZqwIDAQAB' // 从后台获取公钥，这里省略，直接赋值
  
      const encryptor = new JSEncrypt() // 新建JSEncrypt对象
      encryptor.setPublicKey(publicKey) // 设置公钥
      //console.log(data);
      const rsaData = encryptor.encryptLong(
        data
      )
      return rsaData
    }
    
    /**
     * MD5 加密
     * @param {*} value 
     */
    static md5(data) {
      var md5 = require('js-md5')
      return md5(data)
    }
  
    /**
     * 判断输入值是否为空
     */
    static required(value) {
      if (value == null) {
        return false 
      }
      if (typeof value == 'undefined') {
        return false
      }
      if (typeof value === 'number') {
        value = value.toString()
      } else if (typeof value === 'boolean') {
        return !0
      }
      value = value.trim()
      return value && value.length > 0
    }
  
    /**
     * 打开新页面 
     */
    static openWindow(url, title, w, h) {
        // Fixes dual-screen position   Most browsers      Firefox
        //@ts-ignore
        const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.availLeft
        //@ts-ignore
        const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.availTop
        
        const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
        const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height
    
        const left = ((width / 2) - (w / 2)) + dualScreenLeft
        const top = ((height / 2) - (h / 2)) + dualScreenTop
        const newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left)
    
        // Puts focus on the newWindow
        if ( newWindow && typeof window.focus == 'function') {
            newWindow.focus()
        }

    }
  
      /**
       * 判断当前是否处于wifi环境下
       * @author 肖黎望
       * @date 2020-11-27
       * @returns {any}
       */
      static isWifi(){
          //@ts-ignore
          var connection = navigator.connection||navigator.mozConnection||navigator.webkitConnection||{tyep:'unknown'};
          var type = connection.type || connection.effectiveType
          return  type === 'wifi'
      }
  
      static get host_3d(){
          var host = 'https://m-t-3dview.laozicloud.com'
          if(process.env.MODE == 'pro'){
              host = 'https://m-3dview.laozicloud.com'
          }
          if(location.origin.includes('localhost')){
              host = 'http://localhost:3010'
          }
          return host
      }
  
      static toLoginPage(newPage=false, returnURL) {
          var url = process.env.MODE == 'pro' ? 'https://www.laozicloud.com/loginSystem/' : 'https://www.laozicloud.net/loginSystem/'
          if (location.href.includes('localhost')) {
              url = 'http://localhost:8080/'
          }
          if(newPage){
              window.open(`${url}/?returnURL=${returnURL ? encodeURIComponent(returnURL) : encodeURIComponent(location.href)}`)
          }else{
              location.href = `${url}/?returnURL=${returnURL ? encodeURIComponent(returnURL) : encodeURIComponent(location.href)}`
          }
      }
  
  }
  
  